import { createSelector } from '@ngrx/store';
import { surveyFeature } from '../survey.feature';
import {
  DRAWABLE_BULK_OPERATIONS,
  PATCHABLE_BULK_OPERATIONS,
} from './bulk-edit-state.constants';

const { selectBulkOperation } = surveyFeature;

export const selectSelectedSurveys = createSelector(
  selectBulkOperation,
  ({ selected }) => selected,
);

export const selectBulkStats = createSelector(
  selectBulkOperation,
  ({ stats }) => stats,
);

export const selectSelectedBulkOperation = createSelector(
  selectBulkOperation,
  ({ operation }) => operation,
);

export const selectIsDrawableBulkOperation = createSelector(
  selectBulkOperation,
  ({ operation }) =>
    !!operation && DRAWABLE_BULK_OPERATIONS.includes(operation),
);

export const selectIsPatchableBulkOperation = createSelector(
  selectBulkOperation,
  ({ operation }) =>
    !!operation && PATCHABLE_BULK_OPERATIONS.includes(operation),
);
